import { useTelemetry, Telemetry } from "./telemetry-context"

export type { TelemetryValue, TelemetryProps } from "./telemetry-context"

// This file contains functions that allow components to `emit` events to the
// page. Consumers can `listen` for these events to trigger functions.

export type EventCallback = (payload: Record<string, unknown>) => void

const listeners: Record<string, EventCallback[]> = {}

export const EVENTS = {
  MODAL_OPEN: "modal_open",
  BUTTON_CLICK: "button_click"
} as const

/**
 * Broadcasts an event that listeners can detect.
 */
export function emit(name: string, payload: Record<string, unknown>): void {
  if (listeners[name]) {
    listeners[name].forEach(callback => callback(payload))
  }
}

/**
 * Listens for an event with a specific name, and invokes the callback function
 * when it occurs. Returns a function that can be used to stop listening.
 */
export function listen(name: string, fn: EventCallback): () => void {
  if (!listeners[name]) {
    listeners[name] = []
  }

  listeners[name].push(fn)

  return () => {
    listeners[name] = listeners[name].filter(callback => callback !== fn)
  }
}

/**
 * Clears all listeners. Useful when navigating without a full page reload.
 */
export function reset(): void {
  Object.keys(listeners).forEach(key => {
    listeners[key] = []
  })
}

export { useTelemetry, Telemetry }
export { useTelemetryEmitter } from "./use-telemetry-emitter"
